<script lang="ts">
    import Divider from "../components/Divider.svelte";
    import Submit from "../components/Submit.svelte";

    let version = "1.0.0";
    fetch(location.href, { method: "HEAD" }).then((response) => {
        version = response.headers.get("X-Version");
    });
</script>

<main>
    <Divider>Welcome | Bienvenue</Divider>
    <p>
        Bienvenue dans l'outil de validation des installations. Nous allons vous
        assister dans la procédure de vérification du bon fonctionnement des
        boîtiers Ubispot.
    </p>
    <p>
        Cette procédure prend généralement <b>moins d'une minute !</b>
    </p>
    <Divider>Avant de commencer</Divider>
    <ul>
        <li>Vous avez consulté la notice de montage</li>
        <li>Vous avez installé le boitier</li>
        <li>Vous êtes à proximité du véhicule</li>
        <li>Vous avez mis <b>le contact sur ON</b></li>
        <li>Le véhicule est en extérieur et/ou vous captez le GPS</li>
        <li>Votre téléphone est équipé d'un appareil photo</li>
    </ul>

    <Submit>Commencer</Submit>
    <span class="version">Version {version}</span>
</main>

<style>
    li {
        padding: 10px;
    }
    .version {
        position: absolute;
        bottom: 0;
        right: 0;
        margin: 10px;
        font-size: small;
    }
</style>
